module.exports = __webpack_public_path__ + "static/media/share-grey.da46787d.svg";